import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useActiveTemplateId } from './use-active-project-template';
const hasSetupSpacesInTemplate = ()=>createSelector((state)=>state.templates.project, (_, templateId)=>templateId, (project, templateId)=>project.data[templateId].spaceSetup);
export const useHasSetupSpacesInTemplate = ()=>{
    const templateId = useActiveTemplateId();
    const hasSetupSpacesInTemplateObject = useMemo(hasSetupSpacesInTemplate, []);
    return useSelector((state)=>hasSetupSpacesInTemplateObject(state, templateId));
};
